import { rest, graphql } from 'msw'


export const handlers = [
  // Handles a POST /login request
  rest.post('http://drupal.docker.localhost/oauth/token', (req, res, ctx) => {
    return res(
      ctx.json({
        "token_type":"Bearer",
        "expires_in":86400,
        "access_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjczZTBiZWY0ZjBkNmU2NzRjYmVjZDdmNTQ2ODNkMWU4MmMzYmNlZjRlMTIwMWJkN2Y4M2FiODg0YzVkYjQ1MDA1NjhjOGJmZjdmN2UzYzFiIn0.eyJhdWQiOiI3MDZhY2QzNy1iZGNiLTQyM2EtYjhjMy1iZDZjNGUxNDA0ODgiLCJqdGkiOiI3M2UwYmVmNGYwZDZlNjc0Y2JlY2Q3ZjU0NjgzZDFlODJjM2JjZWY0ZTEyMDFiZDdmODNhYjg4NGM1ZGI0NTAwNTY4YzhiZmY3ZjdlM2MxYiIsImlhdCI6MTY1NzAyOTc1OCwibmJmIjoxNjU3MDI5NzU4LCJleHAiOjE2NTcxMTYxNTgsInN1YiI6IjEiLCJzY29wZXMiOlsiYXV0aGVudGljYXRlZCIsImFuYWx5c3QiLCJhcHBfdXNlciIsImN1c3RvbWVyIiwiZGF0YV9lbnRyeV8xIiwiZGF0YV9lbnRyeV8yIiwiZGF0YV9lbnRyeV8zIiwianVuaW9yX2FuYWx5c3QiLCJyZXNlYXJjaCJdfQ.UFLnYF57Q7u9Ts16agwpmfGYHYtp_4IWwggSz_70q4H7NzLoVmEtF4oNLJ6QxrmITtETKyKOqwDeo3wp_9lUsUHlmWpOQxqC-gwmAgKOISozpWMf7VhP1n_NWtY_FCFOgMIW_I9_K1cV-Cc87LSRWqsDe6NkdJsSHXW5GOt2XY3qng9j6bVjlp7siXjY8YVVjOOMEv7zWw4e2eJRVHOsss0PO1SR-g7x5yQeoXQmJZH6jxYx2fJqGFN98TWPeGTqP3UV0OYgifvoefis6M413CA__2uxlvUdJ0w_s5bpCFRzw-Z7I9rEETLyzljNDCE-oKSBOhn51VtjBgJfcsApieO9PaKotcuD2eE_PLCG07pr-ZvffZgmSKOPQZFJNs5ur4EtGhxEETqw1GzHm6CVYAAlQlas0W5uvWFxJN_LywFA-EotAQREKQbm-feuROhErKOeKKuOu62uFZhcXAu0tQWQUmyt0BcQOZc-DGU50-NZImfyBAshflbtJmJHnxTAnqKs-dWiVnrJqTPmnkDpfozY2I57J0e3GXIHSw62JluJPNrDo_zgcgAc00752aSgO4YsQXVIdmPHYLnkNCp_1N9tJYKe1BsERnTYgZk6IuNgTf1M_qGeAaHpRQE68FCZvsixrz9cPkqmlGcgRS-LnAHQ0HHe_tpbiOng_GD-wsY","refresh_token":"def502009f0c90a10afd795c4f27ef438ae5f0e0db3acc1277d2c56de760f01b5451977443e27fefa28875778af6dc5b80543509dc07e2862e03fb760f2202cc3c24707248f6feccb052fb3fd1988b64b798e63e524d17cacba13b9f9a411f445730a0fbe213a09f3c75a1cc9aad33a6013e7e9879a750241c79e9922079461211d766f8efd162200a3f34d5552849c4503f041b145c98ffdb9bfb848b2194c49cb7e4d00cdbb4895aefebcd41fdb5a964fed46df287f2c7dd93f87ad3cefcd2f4cdf31a0a564ab2689d681127c60afe76cd765bf66fc83471d2fe9da990f692cf9657000dc6db60f13d67b04624d2899f901d86b2af7011db3856edc125b99a92c7788227546b939afe7a9ff2d89b8fa596e74270536cee5f11f6934a3a1bf19e6d66828de6f19111a20cde3139ac2a13ad3b8513c9bb16551426aa418d1c2031735c072c78fdf1a81929ae9a4915720903501deeaa44325c249086a9d251eeb02fa48a197edb992150b04a8aa36cb71eaab6aa687ceb0c2bc8717bf2c82fb8e956dce87a580be87a7a279b6239c8b8fb701f4c2e29adae46b93afde25e706c06474ee14b91cdb48cb69aa89aa72293966b583401f12f51e5a95a7d5f8a8c0110bc722738a24a02f88f4192b44f683e48fb300ca44b82c862970cc2ed76a3ac120240b11b0e7414792dcd111da8885d8feb3a51ad3f70248fe10be2a9b2"
      }),
    )
  }),

  graphql.query('getQueueItemsShort', (req, res, ctx) => {
    return res(
      ctx.data(
        {"queueItems":{
          "items":[
            {
              "id":20562,
              "name":"Chesapeake - Independent City - Virginia",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":1952,
              "name":"St. Mary\u0027s - Maryland",
              "type":"subdivision",
              "__typename":"Subdivision"},
            {
              "id":2162,
              "name":"Boone - Kentucky",
              "type":"subdivision",
              "__typename":"Subdivision"
            },
            {
              "id":17017,
              "name":"Newark - Essex - New Jersey",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":9926,
              "name":"Lawton - Comanche - Oklahoma",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":20728,
              "name":"Dolton - Cook - Illinois",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":3420,
              "name":"San Diego - San Diego - California",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":18274,
              "name":"Asheville  - Buncombe - North Carolina",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":20707,
              "name":"Allegany - Maryland",
              "type":"subdivision",
              "__typename":"Subdivision"
            },
            {
              "id":20709,
              "name":"Swainsboro - Emanuel - Georgia",
              "type":"locality",
              "__typename":"Locality"
            },
            {
              "id":20725,
              "name": "Brookfield - Cook - Illinois",
              "type":"locality",
              "__typename":"Locality"
            },
            {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
            {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
            {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
            {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":342,"name":"Albemarle - Virginia","type":"subdivision","__typename":"Subdivision"},
            {"id":337,"name":"Arlington - Virginia","type":"subdivision","__typename":"Subdivision"},
            {"id":20729,"name":"Gautier - Jackson - Mississippi","type":"locality","__typename":"Locality"},
            {"id":19276,"name":"Middletown - Butler - Ohio","type":"locality","__typename":"Locality"},
            {"id":19063,"name":"Stallings - Union - North Carolina","type":"locality","__typename":"Locality"},
            {"id":20730,"name":"Marietta - Washington - Ohio","type":"locality","__typename":"Locality"},
            {"id":20731,"name":"Oelwein - Fayette - Iowa","type":"locality","__typename":"Locality"},
            {"id":20732,"name":"Maquoketa - Jackson - Iowa","type":"locality","__typename":"Locality"},
            {"id":20734,"name":"Wilmington - Will - Illinois","type":"locality","__typename":"Locality"},
            {"id":20735,"name":"Westland - Wayne - Illinois","type":"locality","__typename":"Locality"},
            {"id":20736,"name":"Oakland - Bergen - New Jersey","type":"locality","__typename":"Locality"},
            {"id":20737,"name":"Newtown Square - Delaware - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":20738,"name":"Deerfield - Franklin - Massachusetts","type":"locality","__typename":"Locality"},
            {"id":20739,"name":"Hilton Head Island - Beaufort - South Carolina","type":"locality","__typename":"Locality"},
            {"id":64,"name":"Teton - Wyoming","type":"subdivision","__typename":"Subdivision"},
            {"id":20741,"name":"Woodhaven - Wayne - Michigan","type":"locality","__typename":"Locality"},
            {"id":20742,"name":"Stonelick - Clermont - Ohio","type":"locality","__typename":"Locality"},
            {"id":20743,"name":"Bethel - Clermont - Ohio","type":"locality","__typename":"Locality"},
            {"id":20744,"name":"Inkster - Wayne - Michigan","type":"locality","__typename":"Locality"},
            {"id":18344,"name":"Kannapolis - Cabarrus - North Carolina","type":"locality","__typename":"Locality"},
            {"id":20745,"name":"Florham Park - Morris - New Jersey","type":"locality","__typename":"Locality"},
            {"id":20746,"name":"Van Buren - Wayne - Michigan","type":"locality","__typename":"Locality"},
            {"id":20748,"name":"Delhi - Ingham - Michigan","type":"locality","__typename":"Locality"},
            {"id":849,"name":"Anderson - South Carolina","type":"subdivision","__typename":"Subdivision"},
            {"id":6683,"name":"Acton - Middlesex - Massachusetts","type":"locality","__typename":"Locality"},
            {"id":3828,"name":"Wenatchee - Chelan - Washington","type":"locality","__typename":"Locality"},
            {"id":20750,"name":"Jeffersonville - Clark - Indiana","type":"locality","__typename":"Locality"},
            {"id":566,"name":"Fayette - Texas","type":"subdivision","__typename":"Subdivision"},
            {"id":9618,"name":"Rio Grande City - Starr - Texas","type":"locality","__typename":"Locality"},
            {"id":20011,"name":"Millbrook - Autauga - Alabama","type":"locality","__typename":"Locality"},
            {"id":9045,"name":"Mission - Hidalgo - Texas","type":"locality","__typename":"Locality"},
            {"id":15394,"name":"South Heidelberg - Berks - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":1746,"name":"DeSoto - Mississippi","type":"subdivision","__typename":"Subdivision"},
            {"id":16419,"name":"Union - Crawford - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":16721,"name":"Lebanon  - Lebanon - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":2811,"name":"Indian River - Florida","type":"subdivision","__typename":"Subdivision"},
            {"id":15206,"name":"DeSoto - Louisiana","type":"subdivision","__typename":"Subdivision"},
            {"id":20622,"name":"Sophia - Randolph - North Carolina","type":"locality","__typename":"Locality"},
            {"id":20589,"name":"Blue Mound - Macon - Illinois","type":"locality","__typename":"Locality"},
            {"id":15306,"name":"West Monroe - Ouachita - Louisiana","type":"locality","__typename":"Locality"},
            {"id":3416,"name":"Lemon Grove - San Diego - California","type":"locality","__typename":"Locality"},
            {"id":6609,"name":"Williams - Coconino - Arizona","type":"locality","__typename":"Locality"},
            {"id":4165,"name":"Wales - Androscoggin - Maine","type":"locality","__typename":"Locality"},
            {"id":4164,"name":"Turner - Androscoggin - Maine","type":"locality","__typename":"Locality"},
            {"id":4304,"name":"Chelsea - Kennebec - Maine","type":"locality","__typename":"Locality"},
            {"id":4153,"name":"Lewiston - Androscoggin - Maine","type":"locality","__typename":"Locality"},
            {"id":17404,"name":"Easton - Talbot - Maryland","type":"locality","__typename":"Locality"},
            {"id":17668,"name":"Shenandoah - Page - Virginia","type":"locality","__typename":"Locality"},
            {"id":8999,"name":"Buda - Hays - Texas","type":"locality","__typename":"Locality"},
            {"id":16391,"name":"Woodcock - Crawford - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":15407,"name":"Martinsburg - Blair - Pennsylvania","type":"locality","__typename":"Locality"},
            {"id":13955,"name":"Southeast - Putnam - New York","type":"locality","__typename":"Locality"},
            {"id":10441,"name":"Jenks - Tulsa - Oklahoma","type":"locality","__typename":"Locality"},
            {"id":823,"name":"Laurens - South Carolina","type":"subdivision","__typename":"Subdivision"},
            {"id":331,"name":"Brunswick - Virginia","type":"subdivision","__typename":"Subdivision"},{
            "id":279,"name":"Nottoway - Virginia","type":"subdivision","__typename":"Subdivision"},
            {"id":305,"name":"Greene - Virginia","type":"subdivision","__typename":"Subdivision"},
            {"id":17110,"name":"Harrison - Hudson - New Jersey","type":"locality","__typename":"Locality"},
            {"id":3428,"name":"Lodi - San Joaquin - California","type":"locality","__typename":"Locality"}
          ],"total":74,"__typename":"JurisdictionSelectConnection"}})
    )
  }),

  graphql.query('UserQuery', (req, res, ctx) => {
    return res(
      ctx.data({
        "currentUser":{
          "id":1,
          "mail":"zac@worxco.net",
          "name":"admin",
          "roles":["authenticated","administrator","app_user","data_entry_1","data_entry_2","data_entry_3"],
          "__typename":"User"
        }
      })
    )
  }),

  graphql.query('getClaimedQueueItems', (req, res, ctx) => {
    //const { queue } = req.variables;

    //switch (queue) {
      //case 'main_workflow':
        return res(
          ctx.data({"claimedQueueItems":{"items":[
                {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
                {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
                {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
                {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
                {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
              ],"total":5,"__typename":"JurisdictionSelectConnection"}}
          )
        )
      /*case 'use_workflow':
        return res(
          ctx.data({"claimedQueueItems":{"items":[
                {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
                {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
                {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
                {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
                {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
              ],"total":5,"__typename":"JurisdictionSelectConnection"}}
          )
        )
      case 'requirements_workflow':
        return res(
          ctx.data({"claimedQueueItems":{"items":[
                {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
                {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
                {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
                {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
                {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
              ],"total":5,"__typename":"JurisdictionSelectConnection"}}
          )
        )
    }*/


  }),

  /*graphql.query('getClaimedQueueItems', (req, res, ctx) => {
    return res(
      ctx.data({"claimedQueueItems":{"items":[
            {"id":20725,"name":"Brookfield - Cook - Illinois","type":"locality","__typename":"Locality"},
            {"id":20726,"name":"Buffalo Grove - Lake - Illinois","type":"locality","__typename":"Locality"},
            {"id":2711,"name":"Glynn - Georgia","type":"subdivision","__typename":"Subdivision"},
            {"id":955,"name":"Coos - Oregon","type":"subdivision","__typename":"Subdivision"},
            {"id":20727,"name":"Abington - Montgomery - Pennsylvania","type":"locality","__typename":"Locality"}
          ],"total":5,"__typename":"JurisdictionSelectConnection"}}
      )
    )
  })*/
];
